import {ScriptThingyView} from '../view/table_view';
import {connect} from "react-redux";
import { RootState } from "../../../app/store"
import { Dispatch } from '@reduxjs/toolkit';
import { requestDataFromAPI,requestDataDeletionFromAPI} from '../thunk/table_tunc';


interface OwnProps {
    id:string
}

function mapStateToProps(state:RootState, ownProps:OwnProps){  
    const myprops=
    {
        model:state.ScriptData.model, //state.UpdateData.model,
        scanmasterlist:"false",
        visible: false,
        condition: true,
        itemToDelete: "null",
        view:state.ScriptData.view,      
    }
    return myprops;
}

function bindDispatchToActions(dispatch:Dispatch<any>, ownProps:OwnProps){
    return {
        onLoadRequested:()=>{ 
            dispatch(requestDataFromAPI() as any);
        },
        onDeleteRequested:(item:string)=>{
           dispatch(requestDataDeletionFromAPI(item) as any);
        },
        
    }
}


const ScriptContainer=connect(mapStateToProps, bindDispatchToActions)(ScriptThingyView);
export default ScriptContainer;